import { create } from 'zustand';

import { UploadRepository, type QltUploadFile } from '../../api/repository/upload';
import { normalizeError } from '../../api/core/errors';
import { MAX_UPLOAD_SIZE_LABEL } from '../../board/upload/validation';
import { userErrorMessage } from '../userError';

export interface QltUploadState {
  /** Newest first, every kind; the panel sorts them into tabs. */
  files: QltUploadFile[];
  uploading: boolean;
  error: string | null;
  upload: (files: File[]) => Promise<QltUploadFile[]>;
  clearError: () => void;
}

export const useQltUploadStore = create<QltUploadState>((set, get) => ({
  files: [],
  uploading: false,
  error: null,
  async upload(files) {
    set({ uploading: true, error: null });
    try {
      const uploaded = await UploadRepository.uploadFiles(files);
      set({ files: uploaded.concat(get().files), uploading: false });
      return uploaded;
    } catch (error) {
      // formidable refuses an oversized body with 413 before Strapi sees it
      const tooLarge = normalizeError(error).status === 413;
      set({ uploading: false, error: tooLarge ? `Tệp vượt quá giới hạn ${MAX_UPLOAD_SIZE_LABEL} của máy chủ.` : userErrorMessage(error) });
      return [];
    }
  },
  clearError: () => set({ error: null }),
}));
